import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const BackgroundBlur = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9998;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  background: rgba(0, 0, 0, 0.2);
`;

const PopupContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 20px;
  max-width: 420px;
  font-family: sans-serif;
`;

const Title = styled.h3`
  margin-top: 0;
  font-size: 1.1rem;
`;

const Text = styled.p`
  font-size: 0.9rem;
  margin: 8px 0;
`;

const ButtonGroup = styled.div`
  margin-top: 12px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const Button = styled.button`
  padding: 8px 16px;
  background: #007aff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #005ecc;
  }
`;

const DeclineButton = styled(Button)`
  background: #e53935;

  &:hover {
    background: #c62828;
  }
`;

export default function GDPRModal({ onAccept }: { onAccept: () => void }) {
  const [declined, setDeclined] = useState(false);

  useEffect(() => {
    localStorage.setItem('gdpr_shown', 'true');
  }, []);

  const handleDecline = () => {
    setDeclined(true);
  };

  const handleGoHome = () => {
    window.location.href = '/signin';
  };

  return (
    <>
      <BackgroundBlur />
      <PopupContainer>
        {!declined ? (
          <>
            <Title>Data Processing Notice (GDPR)</Title>
            <Text>
              We process and store your personal and health-related data on secure servers located in the
              European Economic Area (EEA), in compliance with GDPR.
            </Text>
            <Text>
              You retain all rights under the law, including access, correction, and deletion.
              By continuing, you agree to this processing and our{' '}
              <a href="https://www.menhealth.me/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>.
            </Text>
            <ButtonGroup>
              <Button onClick={onAccept}>Accept & Continue</Button>
              <DeclineButton onClick={handleDecline}>Decline</DeclineButton>
            </ButtonGroup>
          </>
        ) : (
          <>
            <Title>Access Denied</Title>
            <Text>You must accept the terms to use this app.</Text>
            <Button onClick={handleGoHome}>Go Back</Button>
          </>
        )}
      </PopupContainer>
    </>
  );
}
